import React from 'react';
import * as constantClass from '../fileWithConstants';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as anioAcademicoService from '../../services/anioAcademico/anioAcademicoService';
import { classifyAnioAcademicoError } from '../../services/anioAcademico/anioAcademicoDto';
import { LookupModal, LookupSelectButton, LookupActionHeader } from '../common/LookupModal';
import { createLookupSearchHandlers } from '../common/lookupGridSearch';

export class LookupAnioAcademicos extends React.Component {
  constructor(props) {
    super(props);
    this.searchInputRef = React.createRef();
    this.state = {
      show: true,
      loading: true,
      searchInput: '',
      perPage: 5,
      paginationData: [],
      pageCount: 1,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => anioAcademicoService.lookupAniosAcademicos(query),
      defaultPageSize: 5,
      onChange: (gridState) => this.applyGridState(gridState),
    });
    const searchHandlers = createLookupSearchHandlers(
      this,
      this.grid,
      (error) => this.handleAnioAcademicoError(error)
    );
    this.handleSearchInputChange = searchHandlers.handleSearchInputChange;
    this.handleSearchSubmit = searchHandlers.handleSearchSubmit;
  }

  handleModal() {
    this.setState({ show: !this.state.show });
    this.props.hideLookup();
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWAnioAcademico');
    if (canAccess) {
      this.populateData();
    }
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      searchInput: gridState.search,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage,
      showErrorMessage: Boolean(gridState.error),
      errorMessage: gridState.error?.message ?? '',
    });
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handleAnioAcademicoError(error));
  };

  handleItemSelect = (e) => {
    this.props.selectItem(e);
    this.setState({ show: false });
  };

  renderTable(anios) {
    return (
      <table className="md-lookup__table" aria-label="Seleccionar el Año Académico">
        <thead>
          <tr>
            <th scope="col">Descripción</th>
            <LookupActionHeader />
          </tr>
        </thead>
        <tbody>
          {anios.map((anio) => (
            <tr key={anio.anioAcademicoCod}>
              <td>{anio.anioAcademicoDescripcion}</td>
              <LookupSelectButton
                onClick={() => this.handleItemSelect(`${anio.anioAcademicoCod}%${anio.anioAcademicoDescripcion}`)}
              />
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <LookupModal
        show={this.state.show}
        onHide={() => this.handleModal()}
        title="Seleccionar el Año Académico"
        searchInputRef={this.searchInputRef}
        searchInput={this.state.searchInput}
        searchPlaceholder="Ingrese el Año Académico"
        onSearchInputChange={this.handleSearchInputChange}
        onSearchSubmit={this.handleSearchSubmit}
        loading={this.state.loading}
        errorMessage={this.state.showErrorMessage ? this.state.errorMessage : ''}
        pageCount={this.state.pageCount}
        forcePage={this.state.forcePage}
        onPageChange={this.handlePageClick}
      >
        {this.renderTable(this.state.paginationData)}
      </LookupModal>
    );
  }

  handleAnioAcademicoError(error) {
    const outcome = classifyAnioAcademicoError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false,
    });
  }

  async populateData() {
    try {
      await this.grid.load();
    } catch (error) {
      this.handleAnioAcademicoError(error);
    }
  }
}
